/**
 * Format number with thousands separators
 * @param {number|string} num - The number to format
 * @returns {string} Formatted number with spaces as thousand separators
 */
export const formatNumber = (num) => {
  if (num === null || num === undefined || num === '') return '0';
  
  // Convert to string and remove all non-digit characters
  const numStr = String(num).replace(/\D/g, '');
  
  // Parse as integer and format with spaces as thousand separators
  return parseInt(numStr, 10).toLocaleString('ru-RU').replace(/,/g, ' ');
};

/**
 * Parse formatted number back to float
 * @param {string} str - Formatted number string (with spaces as thousand separators)
 * @returns {number} Parsed number
 */
export const parseFormattedNumber = (str) => {
  if (!str) return 0;
  return parseFloat(String(str).replace(/\s+/g, '')) || 0;
};

export default {
  formatNumber,
  parseFormattedNumber
};
